import axios from 'axios'
import { Spin, Button, Result } from 'antd'
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router'
import { isNil } from 'lodash'
import { GreenCircleThumbsUpSVG, RedCircleThumbsDownSVG } from 'src/ui/svgs'
// @ts-ignore
import Env from '../../api/gen/Env'

export const CategoryStakeholderResponse = () => {
  const [isSupport, setIsSupport] = useState<boolean>()
  const [loading, setIsLoading] = useState<boolean>()
  const [error, setError] = useState<Error>()
  const location = useLocation()
  const isCategory = location.pathname.includes('category')

  const { token, support, stakeholderId } = useMemo(() => {
    const params = new URLSearchParams(location.search)
    return {
      token: params.get('token'),
      support: params.get('support'),
      stakeholderId: params.get('stakeholder_id'),
    }
  }, [location])

  useEffect(() => {
    setIsSupport(support === 'yes')
  }, [support])

  const handleSubmitResult = useCallback(
    (responseSupport: boolean) => {
      setIsLoading(true)
      axios
        .post(
          `${Env.api.replace('/graphql', '')}/non-login/sourcing-plan${
            isCategory ? '/basket' : ''
          }/support-survey?token=${token}&support=${responseSupport}&stakeholder_id=${stakeholderId}`,
        )
        .catch(e => setError(e))
        .finally(() => {
          setIsLoading(false)
        })
    },
    [token, stakeholderId, isCategory],
  )

  useEffect(() => {
    if (!isNil(isSupport)) {
      handleSubmitResult(isSupport)
    }
  }, [handleSubmitResult, isSupport])

  return (
    <MainPageLayout>
      {loading ? (
        <SpinWrapper>
          <Spin size="large" />
        </SpinWrapper>
      ) : error ? (
        <Result
          status="error"
          title="Submission Failed"
          subTitle="Please check or report to Curvo Support team support@curvolabs.com."
        />
      ) : (
        <ResponseCard support={!!isSupport} onChangeResponse={() => setIsSupport(old => !old)} />
      )}
    </MainPageLayout>
  )
}

const ResponseCard: React.FC<{ support: boolean; onChangeResponse: () => void }> = ({ support, onChangeResponse }) => {
  return (
    <ResponseCardWrapper>
      <span className="title">Thank you for your response.</span>
      <div className="thumb">{support ? <GreenCircleThumbsUpSVG /> : <RedCircleThumbsDownSVG />}</div>
      <span className="message">
        {support
          ? 'You have indicated that you support the proposed initiative to reduce Antroplasty costs.'
          : 'You have indicated that you DO NOT support the proposed initiative to reduce Antroplasty costs.'}
      </span>
      <div className="change_response">
        <Button
          type="link"
          onClick={() => {
            onChangeResponse()
          }}>
          Change response
        </Button>
      </div>
    </ResponseCardWrapper>
  )
}

const MainPageLayout = styled.div`
  height: 100vh;
  width: 100%;
  background: #f3f5f8;
`

const SpinWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const ResponseCardWrapper = styled.div`
  position: absolute;
  top: calc(50% - 152px);
  left: calc(50% - 300px);
  width: 600px;
  height: 304px;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 40px;

  .title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }

  .message {
    width: 382px;
    margin: auto;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }

  .thumb {
    margin: auto;
  }

  .change_response {
    margin: auto;
  }
`
